<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="vehicle|@@vehicle_data">Informations</span>
      <svg id="checkmark-v" class="checkmark" width="16px" height="12px" viewBox="0 0 8 6" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Enregistré</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Rapport-+-Slideshow-Current" transform="translate(-149.000000, -213.000000)" fill-rule="nonzero">
            <g id="Group" transform="translate(145.000000, 166.000000)">
              <g id="Group-9" transform="translate(0.000000, 35.000000)">
                <g id="Group-10">
                  <path
                    d="M10.8678734,12.1874017 L6.6639304,16.3885707 L5.13212661,14.8577776 C4.87000385,14.6047781 4.45334661,14.6083963 4.19566301,14.8659099 C3.93797941,15.1234234 3.93435877,15.5398058 4.1875254,15.8017555 L6.1916298,17.8045375 C6.45249729,18.0651542 6.87536351,18.0651542 7.136231,17.8045375 L11.8124746,13.1313796 C12.0656412,12.8694298 12.0620206,12.4530475 11.804337,12.1955339 C11.5466534,11.9380203 11.1299961,11.9344021 10.8678734,12.1874017 Z"
                    id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
  <div class="row report-form">
    <form [formGroup]="vehicleForm">
      <label><span i18n="vehicle|@@matriculation">Immatriculation</span> <input type="text" formControlName="immat"
          placeholder="AA 245 AT"></label>
      <label *ngIf="vehicleSettings.orNumber"><span i18n="vehicle|@@repair_number">O.R.</span><input type="text"
          maxlength=10 formControlName="or" placeholder="OR..."></label>
      <label *ngIf="vehicleSettings.vinNumber">V.I.N.<input type="text" maxlength=17 formControlName="vin"
          placeholder="VIN..."></label>
      <label><span i18n="vehicle|@@brand">Marque</span><input type="text" formControlName="brand"
          placeholder="Peugeot"></label>
      <label><span i18n="vehicle|@@model">Modèle</span><input type="text" formControlName="model"
          placeholder="SW 207"></label>
      <label class="otherLabel"><span i18n="vehicle|@@class">Classe</span>
        <ng-select class="select" [items]="vehicleSettings.classes" [bindLabel]="'value'" [bindValue]="'display'"
          [(ngModel)]="selectedClass" [ngModelOptions]="{standalone: true}" [virtualScroll]='true' [searchable]='true'
          notFoundText="---" [clearable]='false' placeholder='Classe...' i18n-placeholder="parameters-cost|@@class"
          (change)="handlerChangeClassName($event)">
        </ng-select>
      </label>
    </form>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/element/vehicle/vehicle.component.html